export function useFlowEngagementExport() {
  const teamStore = useTeamStore()

  function startExport(params: {
    flowId: string
    start: Date
    end: Date
    email?: string
    timezone?: string
  }) {
    const rawPid = teamStore.currentTeam?.pid
    if (!rawPid) return

    const qs = new URLSearchParams({
      flowId: params.flowId,
      start: params.start.toISOString(),
      end: params.end.toISOString(),
      timezone: params.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    })

    if (params.email) {
      qs.set('email', params.email)
    }

    recordAnalyticsEvent(AnalyticsEventTypes.EXPORT_INITIATED, {
      exportType: 'flow_engagements',
      flowId: params.flowId
    })

    const backendUrl = import.meta.env.VITE_APP_BACKEND_HOST
    const url = `${backendUrl}/${rawPid}/downloads/export-flow-engagements?${qs.toString()}`
    window.open(url, '_blank')
  }

  return {
    startExport
  }
}
